module.exports = __webpack_public_path__ + "img/ignacio-bordigoni.82a40b73.jpg";